import { push } from "react-router-redux";
import get from "lodash/get";
import { getCurrentClan } from "helpers/currentAccount";
import * as web2ClientAPI from "web2ClientAPI/web2ClientAPI";

import { updateAccountInfo, syncAccountInfo } from "./ActionAccount";

import { fetchWrapper as fetch, fetchWithSpinner } from "helpers/fetch";

export const CLAN_LEAVE_TOGGLE_FETCHING = 'CLAN_LEAVE_TOGGLE_FETCHING';
export const SELECT_COMMANDER = 'SELECT_COMMANDER';
export const SET_INITITAL_STATE = 'SET_INITITAL_STATE';

export const toggleFetching = () => {
  return {
    type: CLAN_LEAVE_TOGGLE_FETCHING
  };
};

export const selectCommander = newCommanderId => {
  return {
    type: SELECT_COMMANDER,
    newCommanderId
  };
};

export const setInitialState = () => {
  return {
    type: SET_INITITAL_STATE
  };
};

export const forceAccountSync = isLeave => {
  return (dispatch, getState) => {
    const showLeaveClanNotification = () => {
      if (isLeave) {
        web2ClientAPI.sendClanLeaveNotification(getCurrentClan(getState()));
      } else {
        web2ClientAPI.sendClanDisbandNotification(getCurrentClan(getState()));
      }
    };
    const promise = dispatch(syncAccountInfo({ leaveClan: showLeaveClanNotification })).catch(() => {
      showLeaveClanNotification();
      dispatch(updateAccountInfo({
        clanId: null,
        role: null,
        activeInvitesCount: 0,
        activeApplicationsCount: 0,
        accumulativeClanResource: null,
        leveling: null,
        isBonusActivated: null
      }));
      const state = getState();
      dispatch(push(state.urls.root));
      dispatch(setInitialState());
    });
    return fetchWithSpinner(dispatch, promise);
  };
};

export const clanLeave = () => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(toggleFetching());

    const url = state.urls.clanLeave;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(json => {
      const hasError = json.status === 'error' || !!json.error;
      if (hasError) {
        dispatch(toggleFetching());
        const reason = get(json, 'additional_info.reason');
        if (reason === 'lead_cannot_leave_clan') {
          web2ClientAPI.sendClanLeaveErrorNotification(reason);
        } else {
          web2ClientAPI.sendClanLeaveErrorNotification();
        }
      }
      return !hasError;
    }).catch(() => {
      dispatch(toggleFetching());
      web2ClientAPI.sendClanLeaveErrorNotification();
      return false;
    });
  };
};

export const clanDisband = () => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch(toggleFetching());

    const url = state.urls.clanDisband;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(json => {
      dispatch(toggleFetching());
      const hasError = json.status === 'error' || !!json.error;
      if (hasError) {
        web2ClientAPI.sendClanLeaveErrorNotification();
      }
      return !hasError;
    }).catch(() => {
      dispatch(toggleFetching());
      web2ClientAPI.sendClanLeaveErrorNotification();
      return false;
    });
  };
};